import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { UserPlus, FolderPlus, Clock, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function QuickActions() {
  const navigate = useNavigate();

  const actions = [
    {
      icon: UserPlus,
      label: 'New Client',
      description: 'Add a new client to CRM',
      onClick: () => navigate('/clients/new'),
      color: 'bg-blue-100 text-blue-600 hover:bg-blue-200',
    },
    {
      icon: FolderPlus,
      label: 'New Project',
      description: 'Create a new project',
      onClick: () => navigate('/projects/new'),
      color: 'bg-green-100 text-green-600 hover:bg-green-200',
    },
    {
      icon: Clock,
      label: 'Log Time',
      description: 'Track time for a project',
      onClick: () => navigate('/time-tracking'),
      color: 'bg-purple-100 text-purple-600 hover:bg-purple-200',
    },
    {
      icon: FileText,
      label: 'Create Proposal',
      description: 'Generate a new proposal',
      onClick: () => navigate('/proposals/new'),
      color: 'bg-orange-100 text-orange-600 hover:bg-orange-200',
    },
  ];

  return (
    <Card className="p-6 border-gray-100 shadow-card">
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Quick Actions</h3>
        <p className="text-sm text-gray-500 mt-1">Common tasks for faster workflow</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {actions.map((action) => (
          <Button
            key={action.label}
            variant="outline"
            className="h-auto p-4 flex items-start justify-start gap-3 hover:bg-gray-50 border-gray-200"
            onClick={action.onClick}
          >
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors ${action.color}`}>
              <action.icon className="w-5 h-5" />
            </div>
            <div className="text-left">
              <p className="font-medium text-gray-900 text-sm">{action.label}</p>
              <p className="text-xs text-gray-500 mt-0.5">{action.description}</p>
            </div>
          </Button>
        ))}
      </div>
    </Card>
  );
}
